import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.5 1.5C8.42893 1.5 6.75 3.17893 6.75 5.25V11.25C6.75 12.4926 7.75736 13.5 9 13.5C10.2426 13.5 11.25 12.4926 11.25 11.25V5.25C11.25 4.83579 10.9142 4.5 10.5 4.5C10.0858 4.5 9.75 4.83579 9.75 5.25V11.25C9.75 11.6642 9.41421 12 9 12C8.58579 12 8.25 11.6642 8.25 11.25V5.25C8.25 4.00736 9.25736 3 10.5 3C11.7426 3 12.75 4.00736 12.75 5.25V11.25C12.75 13.3211 11.0711 15 9 15C6.92893 15 5.25 13.3211 5.25 11.25V8.25C5.25 7.83579 4.91421 7.5 4.5 7.5C4.08579 7.5 3.75 7.83579 3.75 8.25V11.25C3.75 14.1495 6.10051 16.5 9 16.5C11.8995 16.5 14.25 14.1495 14.25 11.25V5.25C14.25 3.17893 12.5711 1.5 10.5 1.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }